/**
 * Questionnaire Scoring Mode Enum
 * Defines how questionnaire scores should be calculated
 */
export enum QuestionnaireScoringMode {
  Average = 1,  // Calculate average score per category
  Sum = 2       // Calculate sum of all scores per category
}
